import re from '@/api/wholesale/receipt'
import moment from 'moment'
import { uniqBy } from 'lodash'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  dateRange: [
    moment().add(-1, 'months').format('DD-MM-YYYY'),
    moment().format('DD-MM-YYYY')
  ],
  invoices: [],
  customers: [],
  approve_status: '',
  branch_id: [],
  location_id: [],
  searchAllDate: false
}

export const getters = {
  filterInvoice: state => stockOutId => {
    return state.invoices
      .filter(e => e.stock_out_id == stockOutId && e.amount_due > 0)
      .reduce((i, v) => (i = v), null)
  },
  customerList: state => {
    return uniqBy(
      state.invoices.map(el => ({
        value: el.customer.customer_id,
        label: el.customer.customer_name + '|' + el.customer.contact_number
      })),
      'value'
    )
  }
}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  SET_INVOICE_LIST(state, data) {
    state.invoices = data
  },
  SET_CUSTOMER_LIST(state, data) {
    state.customers = data
  },
  SET_APPROVE_STATUS(state, data) {
    state.approve_status = data
  },
  SET_BRANCH_ID(state, data) {
    state.branch_id = data
  },
  SET_LOCATION_ID(state, data) {
    state.location_id = data
  },
  UPDATE_AMOUNT_DUE(state, { stockOutId, amount, nextPaymentDate }) {
    let filter = state.invoices
      .filter(e => e.stock_out_id == stockOutId)
      .reduce((i, v) => (i = v), null)
    filter.amount_due = amount
    filter.next_payment_date = nextPaymentDate
  },
  SET_SEARCH_ALL_DATE(state, data) {
    state.searchAllDate = data
  },
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        location_id: context.state.location_id,
        filter: {
          search: context.state.search,
          approve_status: context.state.approve_status,
          date_between: _.join((context.state.searchAllDate && context.state.search) ? undefined : context.state.dateRange, ',')
        }
      },
      attrubutes
    )
    return re.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return re.store(data)
  },
  async getInvoice(context, customer_id) {
    return re.getInvoice(customer_id)
  },
  async fetchCustomer(context) {
    let response = await re.getCustomer()
    context.commit('SET_CUSTOMER_LIST', response.data)
  },
  reprint(context, id) {
    return re.reprint(id)
  },
  destroy(context, { id, data }) {
    return re.destroy(id, data)
  },
  bankProfile(context, attributes = {}) {
    return re.bankProfile()
  },
  confirm(context, data) {
    return re.confirm(data)
  },
  paymentMethod(context, attributes = {}) {
    return re.paymentMethod()
  },
  exportExel(context, attrubutes = {}) {
    let params = Object.assign(
      {
        branch_id: context.state.branch_id,
        location_id: context.state.location_id,
        // filter: {
        search: context.state.search,
        approve_status: context.state.approve_status,
        date_between: _.join(context.state.dateRange, ',')
        // }
      },
      attrubutes
    )
    return re.exportExel(params)
  },
  getFormViewData(context, { params }) {
    return re.formViewModel({ params: params })
  },
  getReceiptList(context, customer_id) {
    return re.getReceiptList(customer_id)
  },
  onLoanRequest(context, data) {
    return re.loanRequest(data)
  }
}
